<h4 *ngIf="!!category?.label">{{ category.label | translateLabel }}</h4>
<ng-container *ngFor="let question of category?.questions">
    <smvd-shared-question-container
        *ngIf="question.type === containerType.Container; else isQuestion"
        [container]="question"
        [group]="group"
    ></smvd-shared-question-container>
    <ng-template #isQuestion>
        <app-question-component *ngIf="showQuestion(question)" [group]="group" [question]="question"></app-question-component>
    </ng-template>
</ng-container>
